import React, { useState, useContext, useEffect } from 'react'
import { Tooltip } from 'antd'
import { makeApiRequest } from '../common'
import arcmIcons from '../Icons'
import Modal from '../components/core/Modal'
import connectionContext from '../context/connectionContext'

const AwsConfigure = ({ onvVeiwChange, ...props }) => {
  const [isOpen, setIsOpen] = useState(false)
  const [loading, setLoading] = useState(true)
  const [modifyConnection, setModifyConnection] = useState(false)
  const [ConnectionErrorMsg, setConnectionErrorMsg] = useState('')
  const {
    awsConnection,
    handleAwsconnection,
    handleOnboardingComplete,
    rdsCredential,
    setRdsCredential
  } = useContext(connectionContext)
  const [rdsConnectionnTitle, setRdsConnectionTitle] = useState(
    'Connecting to Remote Database'
  )
  const [rdsConnectionDesc, setRdsConnectionDesc] = useState(
    'The connection is being established. Please wait....'
  )

  const handleRdsConnection = async () => {
    setIsOpen(true)
    setLoading(true)
    const rdsConnection = await makeApiRequest(
      'rds-connection',
      'POST',
      rdsCredential
    )
    if (rdsConnection.success) {
      handleAwsconnection(true)
      if (!('rds_credential' in archm_admin.archm_settings)) {
        archm_admin.archm_settings.rds_credential = rdsCredential
      }else{
        Object.assign(archm_admin.archm_settings.rds_credential, rdsCredential)
      }
      setRdsConnectionTitle('Successfully Database Connected.')
      setRdsConnectionDesc('WordPress Schema Creating')
      const installWordpress = await makeApiRequest(
        'install-wordpress',
        'POST',
        rdsCredential
      )
      console.log(installWordpress)
      if (installWordpress.success) {
        setLoading(false)
        setConnectionErrorMsg(installWordpress.message)
      }
    } else {
      setLoading(false)
      handleAwsconnection(false)
      handleOnboardingComplete(false)
      setConnectionErrorMsg(rdsConnection.message)
    }
  }

  const handleToggleModal = () => {
    setIsOpen(!isOpen)
    setRdsConnectionTitle('Connecting to Remote Database')
    setRdsConnectionDesc('The connection is being established. Please wait....')
  }

  const setModifyConnectionInputFocus = () => {
    setModifyConnection(true)
    setTimeout(() => {
      const db_name = document.querySelector('#db_name')
      db_name.focus() // Ensure focus is set after state update
    }, 0)
  }

  return (
    <div className='aws-configure'>
      <button
        onClick={() => onvVeiwChange('archive_settings')}
        className=' arcm-flex arcm-items-center arcm-justify-center arcm-text-[#3858e9] arcm-text-sm arcm-font-semibold'
      >
        <div className='icon arcm-mr-2'>
          <svg
            xmlns='http://www.w3.org/2000/svg'
            width='8'
            height='14'
            viewBox='0 0 8 14'
            fill='none'
          >
            <path
              d='M7.125 13.25L0.875 7L7.125 0.75'
              stroke='#3858E9'
              stroke-width='1.5'
              stroke-linecap='round'
              stroke-linejoin='round'
            />
          </svg>
        </div>{' '}
        Back to Settings
      </button>

      <div className='aws-configure__edit arcm-mt-4 arcm-px-6 arcm-pt-12 arcm-pb-14 arcm-bg-white arcm-rounded-2xl'>
        <div className='icon arcm-mb-4'>
          <svg
            xmlns='http://www.w3.org/2000/svg'
            width='61'
            height='30'
            viewBox='0 0 61 30'
            fill='none'
          >
            <path
              d='M19.1376 10.8954C19.1376 11.5128 19.2044 12.0133 19.3212 12.3804C19.4546 12.7475 19.6215 13.1479 19.8551 13.5818C19.9385 13.7152 19.9719 13.8487 19.9719 13.9655C19.9719 14.1324 19.8718 14.2992 19.6549 14.4661L18.6037 15.1669C18.4535 15.267 18.3034 15.317 18.1699 15.317C18.003 15.317 17.8362 15.2336 17.6693 15.0834C17.4357 14.8331 17.2355 14.5662 17.0687 14.2992C16.9018 14.0156 16.735 13.6986 16.5514 13.3148C15.25 14.8498 13.6148 15.6174 11.646 15.6174C10.2444 15.6174 9.1265 15.2169 8.30892 14.416C7.49135 13.6151 7.07422 12.5473 7.07422 11.2125C7.07422 9.79422 7.57477 8.64294 8.59257 7.77531C9.61037 6.90768 10.9619 6.47386 12.6804 6.47386C13.2477 6.47386 13.8317 6.52392 14.4491 6.60734C15.0664 6.69077 15.7005 6.82425 16.3679 6.97442V5.7564C16.3679 4.48832 16.1009 3.604 15.5837 3.08676C15.0497 2.56952 14.1487 2.31924 12.864 2.31924C12.28 2.31924 11.6793 2.38598 11.062 2.53615C10.4446 2.68632 9.84396 2.86986 9.25998 3.10345C8.99302 3.22025 8.79279 3.28699 8.676 3.32036C8.5592 3.35373 8.47578 3.37041 8.40904 3.37041C8.17544 3.37041 8.05865 3.20356 8.05865 2.85317V2.0356C8.05865 1.76863 8.09202 1.56841 8.17544 1.45161C8.25887 1.33482 8.40903 1.21802 8.64263 1.10122C9.22661 0.80089 9.92739 0.550612 10.745 0.350389C11.5625 0.133482 12.4302 0.0333704 13.3479 0.0333704C15.3334 0.0333704 16.785 0.483871 17.7194 1.38487C18.6371 2.28587 19.1043 3.65406 19.1043 5.48943V10.8954H19.1376ZM12.3634 13.4316C12.914 13.4316 13.4813 13.3315 14.082 13.1313C14.6827 12.931 15.2166 12.564 15.6671 12.0634C15.9341 11.7464 16.1343 11.396 16.2344 10.9956C16.3345 10.5951 16.4012 10.1112 16.4012 9.54394V8.84316C15.9174 8.72636 15.4001 8.62625 14.8662 8.55951C14.3323 8.49277 13.815 8.4594 13.2978 8.4594C12.1799 8.4594 11.3623 8.67631 10.8117 9.12681C10.2611 9.57731 9.99413 10.2113 9.99413 11.0456C9.99413 11.8298 10.1944 12.4138 10.6115 12.8142C11.0119 13.2314 11.5959 13.4316 12.3634 13.4316ZM25.7616 15.2336C25.4613 15.2336 25.2611 15.1835 25.1276 15.0667C24.9941 14.9666 24.8773 14.733 24.7772 14.416L20.8562 1.51835C20.7561 1.18465 20.706 0.967742 20.706 0.850946C20.706 0.583982 20.8395 0.433815 21.1065 0.433815H22.7416C23.0586 0.433815 23.2756 0.483871 23.3923 0.600667C23.5258 0.700779 23.6259 0.934372 23.7261 1.25139L26.5292 12.297L29.1321 1.25139C29.2155 0.917686 29.3156 0.700779 29.4491 0.600667C29.5826 0.500556 29.8162 0.433815 30.1165 0.433815H31.4513C31.7683 0.433815 31.9852 0.483871 32.1187 0.600667C32.2522 0.700779 32.369 0.934372 32.4357 1.25139L35.072 12.4305L37.9585 1.25139C38.0586 0.917686 38.1754 0.700779 38.2922 0.600667C38.4257 0.500556 38.6426 0.433815 38.943 0.433815H40.4947C40.7616 0.433815 40.9118 0.567297 40.9118 0.850946C40.9118 0.934372 40.8951 1.0178 40.8784 1.11791C40.8618 1.21802 40.8284 1.3515 40.7616 1.53504L36.7405 14.4327C36.6404 14.7664 36.5236 14.9833 36.3901 15.0834C36.2566 15.1835 36.0397 15.2503 35.7561 15.2503H34.3212C34.0041 15.2503 33.7872 15.2002 33.6537 15.0834C33.5203 14.9666 33.4035 14.7497 33.3367 14.416L30.7505 3.65406L28.181 14.3993C28.0976 14.733 27.9975 14.9499 27.864 15.0667C27.7305 15.1835 27.4969 15.2336 27.1966 15.2336H25.7616ZM47.2021 15.6841C46.3345 15.6841 45.4669 15.584 44.6326 15.3838C43.7984 15.1835 43.1476 14.9666 42.7138 14.7164C42.4468 14.5662 42.2633 14.3993 42.1966 14.2492C42.1298 14.099 42.0965 13.9321 42.0965 13.782V12.931C42.0965 12.5806 42.2299 12.4138 42.4802 12.4138C42.5803 12.4138 42.6804 12.4305 42.7806 12.4639C42.8807 12.4972 43.0308 12.564 43.1977 12.6307C43.765 12.881 44.3823 13.0812 45.0331 13.2147C45.7005 13.3482 46.3512 13.4149 47.0186 13.4149C48.0698 13.4149 48.8873 13.2314 49.4546 12.8643C50.0219 12.4972 50.3223 11.9633 50.3223 11.2792C50.3223 10.812 50.1721 10.4283 49.8718 10.1112C49.5714 9.79422 49.0041 9.51057 48.1866 9.2436L45.7672 8.49277C44.5492 8.10901 43.6482 7.54171 43.0976 6.79088C42.547 6.05673 42.2633 5.23915 42.2633 4.37152C42.2633 3.67075 42.4135 3.05339 42.7138 2.51947C43.0141 1.98554 43.4146 1.51835 43.9151 1.15128C44.4157 0.76752 44.983 0.483871 45.6504 0.283649C46.3178 0.083426 47.0186 0 47.7527 0C48.1198 0 48.5036 0.0166852 48.8707 0.0667408C49.2544 0.116796 49.6048 0.183537 49.9552 0.250278C50.2889 0.333704 50.6059 0.41713 50.9062 0.517241C51.2066 0.617353 51.4402 0.717464 51.607 0.817575C51.8406 0.951057 52.0075 1.08454 52.1076 1.23471C52.2077 1.36819 52.2578 1.55172 52.2578 1.78532V2.56952C52.2578 2.91991 52.1243 3.10345 51.874 3.10345C51.7405 3.10345 51.5236 3.03671 51.24 2.90323C50.2889 2.46941 49.221 2.2525 48.0364 2.2525C47.0853 2.2525 46.3345 2.40267 45.8173 2.71969C45.3 3.03671 45.0331 3.52058 45.0331 4.20467C45.0331 4.67186 45.1999 5.0723 45.5336 5.38932C45.8673 5.70634 46.4847 6.02336 47.369 6.30701L49.7383 7.05784C50.9396 7.4416 51.8072 7.97553 52.3245 8.65962C52.8417 9.34372 53.092 10.1279 53.092 10.9956C53.092 11.713 52.9418 12.3637 52.6582 12.931C52.3579 13.4983 51.9574 13.9989 51.4402 14.3993C50.9229 14.8165 50.3056 15.1168 49.5881 15.3337C48.8373 15.5673 48.0531 15.6841 47.2021 15.6841Z'
              fill='#252F3E'
            />
            <path
              fill-rule='evenodd'
              clip-rule='evenodd'
              d='M50.3557 23.793C44.8663 27.8475 36.8908 29.9999 30.0332 29.9999C20.4225 29.9999 11.7629 26.446 5.22225 20.5394C4.70501 20.0722 5.17219 19.4382 5.78955 19.8052C12.8641 23.9098 21.5904 26.3959 30.6171 26.3959C36.7072 26.3959 43.398 25.1278 49.5549 22.5249C50.4725 22.1078 51.2567 23.1256 50.3557 23.793Z'
              fill='#FF9900'
            />
            <path
              fill-rule='evenodd'
              clip-rule='evenodd'
              d='M52.6422 21.1901C51.9414 20.2891 48.0037 20.7563 46.2184 20.9732C45.6844 21.04 45.601 20.5728 46.0849 20.2224C49.2217 18.02 54.3774 18.654 54.9781 19.3881C55.5788 20.139 54.8112 25.2947 51.8746 27.7641C51.4241 28.1479 50.9903 27.9477 51.1905 27.4471C51.858 25.7953 53.3429 22.0745 52.6422 21.1901Z'
              fill='#FF9900'
            />
          </svg>
        </div>
        <div className='arcm-text-gray-900 arcm-text-sm arcm-font-medium arcm-mb-6'>
          AWS RDS
        </div>
        {!awsConnection ? (
          <>
            <div className='arcm-text-gray-800 arcm-text-xl arcm-font-bold arcm-mb-1'>
              Configure Connection
            </div>
            <div className='arcm-text-gray-600 arcm-text-sm arcm-font-normal'>
              Connect to AWS RDS using your credentials
            </div>
            <div className='arcm-text-[#3858E9] arcm-flex arcm-font-[14px] arcm-mt-1'>
              <b>
                <a
                  className='arcm-underline arcm-mr-1 arcm-decoration-1'
                  target='_blank'
                  href='https://console.aws.amazon.com/rds/home'
                >
                  Click here
                </a>
              </b>{' '}
              to go to RDS Portal
              <svg
                className='arcm-ml-2'
                width='24'
                height='24'
                viewBox='0 0 24 24'
                fill='none'
                xmlns='http://www.w3.org/2000/svg'
              >
                <path
                  d='M17.25 8.25L21 12M21 12L17.25 15.75M21 12H3'
                  stroke='#3858E9'
                  stroke-width='1.5'
                  stroke-linecap='round'
                  stroke-linejoin='round'
                />
              </svg>
            </div>
          </>
        ) : (
          <>
            <div className='arcm-wrap arcm-flex arcm-justify-between arcm-items-center arcm-gap-3 arcm-max-w-[671px]'>
              <div className='arcm-wrap__text'>
                <div className='arcm-text-gray-800 arcm-text-xl arcm-font-bold arcm-mb-1'>
                  <span className=' arcm-inline-flex arcm-w-[17px] arcm-h-[17px] arcm-bg-[#27d935] arcm-rounded-full arcm-mr-2'></span>{' '}
                  Connected to RDS
                </div>
                <div className='arcm-text-gray-600 arcm-text-sm arcm-font-normal'>
                  Successfully connected to RDS
                </div>
              </div>
              <div className='arcm-wrap__btn-box'>
                <button
                  onClick={() => setModifyConnectionInputFocus()}
                  className='arcm-text-[#3858e9] arcm-text-sm arcm-font-semibold arcm-px-4 arcm-py-3 arcm-bg-white arcm-rounded-lg arcm-border arcm-border-[#3858e9] arcm-justify-center arcm-items-center arcm-gap-2 arcm-inline-flex arcm-transition-all arcm-group hover:arcm-text-white hover:arcm-bg-[#3858e9]'
                >
                  {arcmIcons.edit} Modify Connection
                </button>
              </div>
            </div>
          </>
        )}
        <div className='arcm-flex arcm-flex-col lg:arcm-flex-row arcm-gap-8'>
          <div className='aws-configure__form arcm-max-w-[671px] arcm-mt-6 arcm-w-[50%] arcm-mr-[126px]'>
            <div className='input-field arcm-mb-4'>
              <label
                htmlFor='db_name'
                className='arcm-text-gray-900 arcm-text-sm arcm-font-medium arcm-block arcm-mb-2'
              >
                <span className='arcm-mr-1'>
                  Database{' '}
                  {!awsConnection && (
                    <span className='arcm-text-slate-400 arcm-text-[13px]'>
                      (Database name should not inlcude any space or capital
                      letter)
                    </span>
                  )}
                </span>
                <Tooltip
                  className='arcm-text-sm'
                  placement='right'
                  title='Enter the database name. It should follow MySQL naming rules. Eg: Database name should not include any space or capital letter'
                  color='#fff'
                >
                  <span className='icon arcm-inline-flex'>
                    <svg
                      xmlns='http://www.w3.org/2000/svg'
                      width='14'
                      height='13'
                      viewBox='0 0 14 13'
                      fill='none'
                    >
                      <path
                        fill-rule='evenodd'
                        clip-rule='evenodd'
                        d='M13.4001 6.49998C13.4001 10.0346 10.5347 12.9 7.0001 12.9C3.46548 12.9 0.600098 10.0346 0.600098 6.49998C0.600098 2.96535 3.46548 0.0999756 7.0001 0.0999756C10.5347 0.0999756 13.4001 2.96535 13.4001 6.49998ZM6.15157 4.05143C5.91725 4.28574 5.53736 4.28574 5.30304 4.05143C5.06873 3.81711 5.06873 3.43721 5.30304 3.2029C6.2403 2.26564 7.75989 2.26564 8.69715 3.2029C9.63441 4.14016 9.63441 5.65975 8.69715 6.59701C8.38317 6.911 8.00238 7.12048 7.6001 7.22404V7.49995C7.6001 7.83132 7.33147 8.09995 7.0001 8.09995C6.66873 8.09995 6.4001 7.83132 6.4001 7.49995V7.09995C6.4001 6.52372 6.85605 6.16258 7.26517 6.07055C7.47868 6.02252 7.68138 5.91573 7.84863 5.74848C8.31725 5.27985 8.31725 4.52006 7.84863 4.05143C7.38 3.5828 6.6202 3.5828 6.15157 4.05143ZM7.0001 10.5C7.44192 10.5 7.8001 10.1418 7.8001 9.69998C7.8001 9.25815 7.44192 8.89997 7.0001 8.89997C6.55827 8.89997 6.2001 9.25815 6.2001 9.69998C6.2001 10.1418 6.55827 10.5 7.0001 10.5Z'
                        fill='#D1D5DB'
                      />
                    </svg>
                  </span>
                </Tooltip>
              </label>
              <input
                disabled={awsConnection && !modifyConnection}
                type='text'
                value={rdsCredential.rds_dbname}
                onChange={e =>
                  setRdsCredential({
                    ...rdsCredential,
                    rds_dbname: e.target.value
                  })
                }
                id='db_name'
                placeholder='RDS database name'
                className='!arcm-p-4 !arcm-bg-white !arcm-rounded-lg !arcm-border !arcm-border-gray-400 !arcm-text-gray-400 !arcm-text-sm !arcm-font-normal !arcm-shadow-none placeholder:!arcm-text-gray-400 !arcm-w-full focus:!arcm-border-[#3858e9]'
              />
            </div>

            <div className='input-field arcm-mb-4'>
              <label
                htmlFor='db_user'
                className='arcm-text-gray-900 arcm-text-sm arcm-font-medium arcm-block arcm-mb-2'
              >
                <span className='arcm-mr-1'>Username</span>
                <Tooltip
                  className='arcm-text-sm'
                  placement='right'
                  title="Enter the username. You'll get this data from RDS Portal"
                  color='#fff'
                >
                  <span className='icon arcm-inline-flex'>
                    <svg
                      xmlns='http://www.w3.org/2000/svg'
                      width='14'
                      height='13'
                      viewBox='0 0 14 13'
                      fill='none'
                    >
                      <path
                        fill-rule='evenodd'
                        clip-rule='evenodd'
                        d='M13.4001 6.49998C13.4001 10.0346 10.5347 12.9 7.0001 12.9C3.46548 12.9 0.600098 10.0346 0.600098 6.49998C0.600098 2.96535 3.46548 0.0999756 7.0001 0.0999756C10.5347 0.0999756 13.4001 2.96535 13.4001 6.49998ZM6.15157 4.05143C5.91725 4.28574 5.53736 4.28574 5.30304 4.05143C5.06873 3.81711 5.06873 3.43721 5.30304 3.2029C6.2403 2.26564 7.75989 2.26564 8.69715 3.2029C9.63441 4.14016 9.63441 5.65975 8.69715 6.59701C8.38317 6.911 8.00238 7.12048 7.6001 7.22404V7.49995C7.6001 7.83132 7.33147 8.09995 7.0001 8.09995C6.66873 8.09995 6.4001 7.83132 6.4001 7.49995V7.09995C6.4001 6.52372 6.85605 6.16258 7.26517 6.07055C7.47868 6.02252 7.68138 5.91573 7.84863 5.74848C8.31725 5.27985 8.31725 4.52006 7.84863 4.05143C7.38 3.5828 6.6202 3.5828 6.15157 4.05143ZM7.0001 10.5C7.44192 10.5 7.8001 10.1418 7.8001 9.69998C7.8001 9.25815 7.44192 8.89997 7.0001 8.89997C6.55827 8.89997 6.2001 9.25815 6.2001 9.69998C6.2001 10.1418 6.55827 10.5 7.0001 10.5Z'
                        fill='#D1D5DB'
                      />
                    </svg>
                  </span>
                </Tooltip>
              </label>
              <input
                disabled={awsConnection && !modifyConnection}
                type='text'
                value={rdsCredential.rds_username}
                onChange={e =>
                  setRdsCredential({
                    ...rdsCredential,
                    rds_username: e.target.value
                  })
                }
                id='db_user'
                placeholder='Enter database username'
                className='!arcm-p-4 !arcm-bg-white !arcm-rounded-lg !arcm-border !arcm-border-gray-400 !arcm-text-gray-400 !arcm-text-sm !arcm-font-normal !arcm-shadow-none placeholder:!arcm-text-gray-400 !arcm-w-full focus:!arcm-border-[#3858e9]'
              />
            </div>

            <div className='input-field arcm-mb-4'>
              <label
                htmlFor='db_password'
                className='arcm-text-gray-900 arcm-text-sm arcm-font-medium arcm-block arcm-mb-2'
              >
                <span className='arcm-mr-1'>Password</span>
                <Tooltip
                  className='arcm-text-sm'
                  placement='right'
                  title="Enter the password. You'll get this data from RDS Portal"
                  color='#fff'
                >
                  <span className='icon arcm-inline-flex'>
                    <svg
                      xmlns='http://www.w3.org/2000/svg'
                      width='14'
                      height='13'
                      viewBox='0 0 14 13'
                      fill='none'
                    >
                      <path
                        fill-rule='evenodd'
                        clip-rule='evenodd'
                        d='M13.4001 6.49998C13.4001 10.0346 10.5347 12.9 7.0001 12.9C3.46548 12.9 0.600098 10.0346 0.600098 6.49998C0.600098 2.96535 3.46548 0.0999756 7.0001 0.0999756C10.5347 0.0999756 13.4001 2.96535 13.4001 6.49998ZM6.15157 4.05143C5.91725 4.28574 5.53736 4.28574 5.30304 4.05143C5.06873 3.81711 5.06873 3.43721 5.30304 3.2029C6.2403 2.26564 7.75989 2.26564 8.69715 3.2029C9.63441 4.14016 9.63441 5.65975 8.69715 6.59701C8.38317 6.911 8.00238 7.12048 7.6001 7.22404V7.49995C7.6001 7.83132 7.33147 8.09995 7.0001 8.09995C6.66873 8.09995 6.4001 7.83132 6.4001 7.49995V7.09995C6.4001 6.52372 6.85605 6.16258 7.26517 6.07055C7.47868 6.02252 7.68138 5.91573 7.84863 5.74848C8.31725 5.27985 8.31725 4.52006 7.84863 4.05143C7.38 3.5828 6.6202 3.5828 6.15157 4.05143ZM7.0001 10.5C7.44192 10.5 7.8001 10.1418 7.8001 9.69998C7.8001 9.25815 7.44192 8.89997 7.0001 8.89997C6.55827 8.89997 6.2001 9.25815 6.2001 9.69998C6.2001 10.1418 6.55827 10.5 7.0001 10.5Z'
                        fill='#D1D5DB'
                      />
                    </svg>
                  </span>
                </Tooltip>
              </label>
              <input
                disabled={awsConnection && !modifyConnection}
                type='password'
                value={rdsCredential.rds_password}
                onChange={e =>
                  setRdsCredential({
                    ...rdsCredential,
                    rds_password: e.target.value
                  })
                }
                id='db_password'
                placeholder='Enter database password'
                className='!arcm-p-4 !arcm-bg-white !arcm-rounded-lg !arcm-border !arcm-border-gray-400 !arcm-text-gray-400 !arcm-text-sm !arcm-font-normal !arcm-shadow-none placeholder:!arcm-text-gray-400 !arcm-w-full focus:!arcm-border-[#3858e9]'
              />
            </div>

            <div className='input-field arcm-mb-4'>
              <label
                htmlFor='db_port'
                className='arcm-text-gray-900 arcm-text-sm arcm-font-medium arcm-block arcm-mb-2'
              >
                <span className='arcm-mr-1'>Port</span>
                <Tooltip
                  className=' arcm-text-sm'
                  placement='left'
                  title="Enter the port. You'll get this data from RDS Portal"
                  color='#fff'
                >
                  <span className='icon arcm-inline-flex'>
                    <svg
                      xmlns='http://www.w3.org/2000/svg'
                      width='14'
                      height='13'
                      viewBox='0 0 14 13'
                      fill='none'
                    >
                      <path
                        fill-rule='evenodd'
                        clip-rule='evenodd'
                        d='M13.4001 6.49998C13.4001 10.0346 10.5347 12.9 7.0001 12.9C3.46548 12.9 0.600098 10.0346 0.600098 6.49998C0.600098 2.96535 3.46548 0.0999756 7.0001 0.0999756C10.5347 0.0999756 13.4001 2.96535 13.4001 6.49998ZM6.15157 4.05143C5.91725 4.28574 5.53736 4.28574 5.30304 4.05143C5.06873 3.81711 5.06873 3.43721 5.30304 3.2029C6.2403 2.26564 7.75989 2.26564 8.69715 3.2029C9.63441 4.14016 9.63441 5.65975 8.69715 6.59701C8.38317 6.911 8.00238 7.12048 7.6001 7.22404V7.49995C7.6001 7.83132 7.33147 8.09995 7.0001 8.09995C6.66873 8.09995 6.4001 7.83132 6.4001 7.49995V7.09995C6.4001 6.52372 6.85605 6.16258 7.26517 6.07055C7.47868 6.02252 7.68138 5.91573 7.84863 5.74848C8.31725 5.27985 8.31725 4.52006 7.84863 4.05143C7.38 3.5828 6.6202 3.5828 6.15157 4.05143ZM7.0001 10.5C7.44192 10.5 7.8001 10.1418 7.8001 9.69998C7.8001 9.25815 7.44192 8.89997 7.0001 8.89997C6.55827 8.89997 6.2001 9.25815 6.2001 9.69998C6.2001 10.1418 6.55827 10.5 7.0001 10.5Z'
                        fill='#D1D5DB'
                      />
                    </svg>
                  </span>
                </Tooltip>
              </label>
              <input
                disabled={awsConnection && !modifyConnection}
                type='number'
                value={rdsCredential.rds_port}
                onChange={e =>
                  setRdsCredential({
                    ...rdsCredential,
                    rds_port: e.target.value
                  })
                }
                id='db_port'
                placeholder='Enter port no'
                className='!arcm-p-4 !arcm-bg-white !arcm-rounded-lg !arcm-border !arcm-border-gray-400 !arcm-text-gray-400 !arcm-text-sm !arcm-font-normal !arcm-shadow-none placeholder:!arcm-text-gray-400 !arcm-w-full focus:!arcm-border-[#3858e9]'
              />
            </div>

            <div className='input-field arcm-mb-4'>
              <label
                htmlFor='db_endpoint'
                className='arcm-text-gray-900 arcm-text-sm arcm-font-medium arcm-block arcm-mb-2'
              >
                <span className='arcm-mr-1'>Endpoint</span>
                <Tooltip
                  className=' arcm-text-sm'
                  placement='right'
                  title="Enter the endpoint. Should not include any https:// and single / in the endpoint You'll get this data from RDS Portal"
                  color='#fff'
                >
                  <span className='icon arcm-inline-flex'>
                    <svg
                      xmlns='http://www.w3.org/2000/svg'
                      width='14'
                      height='13'
                      viewBox='0 0 14 13'
                      fill='none'
                    >
                      <path
                        fill-rule='evenodd'
                        clip-rule='evenodd'
                        d='M13.4001 6.49998C13.4001 10.0346 10.5347 12.9 7.0001 12.9C3.46548 12.9 0.600098 10.0346 0.600098 6.49998C0.600098 2.96535 3.46548 0.0999756 7.0001 0.0999756C10.5347 0.0999756 13.4001 2.96535 13.4001 6.49998ZM6.15157 4.05143C5.91725 4.28574 5.53736 4.28574 5.30304 4.05143C5.06873 3.81711 5.06873 3.43721 5.30304 3.2029C6.2403 2.26564 7.75989 2.26564 8.69715 3.2029C9.63441 4.14016 9.63441 5.65975 8.69715 6.59701C8.38317 6.911 8.00238 7.12048 7.6001 7.22404V7.49995C7.6001 7.83132 7.33147 8.09995 7.0001 8.09995C6.66873 8.09995 6.4001 7.83132 6.4001 7.49995V7.09995C6.4001 6.52372 6.85605 6.16258 7.26517 6.07055C7.47868 6.02252 7.68138 5.91573 7.84863 5.74848C8.31725 5.27985 8.31725 4.52006 7.84863 4.05143C7.38 3.5828 6.6202 3.5828 6.15157 4.05143ZM7.0001 10.5C7.44192 10.5 7.8001 10.1418 7.8001 9.69998C7.8001 9.25815 7.44192 8.89997 7.0001 8.89997C6.55827 8.89997 6.2001 9.25815 6.2001 9.69998C6.2001 10.1418 6.55827 10.5 7.0001 10.5Z'
                        fill='#D1D5DB'
                      />
                    </svg>
                  </span>
                </Tooltip>
              </label>
              <input
                disabled={awsConnection && !modifyConnection}
                type='text'
                value={rdsCredential.rds_endpoint}
                onChange={e =>
                  setRdsCredential({
                    ...rdsCredential,
                    rds_endpoint: e.target.value
                  })
                }
                id='db_endpoint'
                placeholder='Enter the endpoint'
                className='!arcm-p-4 !arcm-bg-white !arcm-rounded-lg !arcm-border !arcm-border-gray-400 !arcm-text-gray-400 !arcm-text-sm !arcm-font-normal !arcm-shadow-none placeholder:!arcm-text-gray-400 !arcm-w-full focus:!arcm-border-[#3858e9]'
              />
            </div>

            <button
              onClick={handleRdsConnection}
              className='arcm-text-white arcm-text-xs sm:arcm-text-sm arcm-font-semibold arcm-px-4 arcm-py-3 arcm-bg-[#3858e9] arcm-rounded-lg arcm-justify-center arcm-items-center arcm-gap-2 arcm-inline-flex arcm-transition-all hover:arcm-bg-blue-700'
            >
              <span>Connect to RDS</span>
            </button>
          </div>
          <div className='arcm-relative arcm-h-[100%] arcm-w-[50%] arcm-m-auto'>
            <span className=' arcm-text-[#111827] arcm-font-[14px] arcm-flex arcm-items-center arcm-text-sm'>
              <svg
                className='arcm-mr-3'
                width='10'
                height='13'
                viewBox='0 0 10 13'
                fill='none'
                xmlns='http://www.w3.org/2000/svg'
              >
                <path
                  d='M0 0.846965C0 0.703037 0.0308334 0.561895 0.0891671 0.435611C0.280835 0.0270432 0.714171 -0.120598 1.05834 0.106899L9.63339 5.75999C9.75005 5.83706 9.84589 5.95128 9.91006 6.08963C10.1017 6.4982 9.97672 7.01355 9.63339 7.24012L1.05834 12.8932C0.953987 12.9634 0.834375 13.0003 0.712504 13C0.319168 13 0 12.6211 0 12.1541V0.846965Z'
                  fill='#374151'
                />
              </svg>{' '}
              Step by step guide to connect to RDS database
            </span>
            <div className='arcm-h-[365px] arcm-w-full arcm-aspect-video arcm-mb-4'>
              <iframe
                className='arcm-h-full arcm-w-full arcm-rounded-[22px]'
                src='https://www.youtube.com/embed/ts7OT9OYbmE?playlist=gLTNZAXYxPY&controls=1&showinfo=0&rel=0'
                allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; fullscreen'
                allowFullScreen
              ></iframe>
            </div>
            <p className='arcm-text-sm arcm-text-left arcm-w-[300px]'>
              Prefer reading? Check out the{' '}
              <a
                target='_blank'
                className='arcm-text-[#3858E9] arcm-underline'
                href='https://wppool.dev/docs-category/archive-master-docs/'
              >
                ArchiveMaster Documentation
              </a>{' '}
              for a written setup guide
            </p>
          </div>
        </div>
      </div>

      <Modal
        openModal={isOpen}
        toggleModal={handleToggleModal}
        outerClick={false}
      >
        {{
          body: loading ? (
            <div className='arcm-text-center arcm-mb-6'>
              <div className='icon arcm-inline-flex'>
                {arcmIcons.SpinningAnimation}
              </div>
              <h5 className='arcm-text-gray-900 arcm-text-base arcm-font-semibold arcm-mb-1.5'>
                {rdsConnectionnTitle}
              </h5>
              <p className='arcm-text-center arcm-text-gray-900 arcm-text-sm arcm-font-normal arcm-mb-6'>
                {rdsConnectionDesc}
              </p>
              <button
                onClick={handleToggleModal}
                className='arcm-text-gray-900 arcm-text-sm arcm-font-semibold arcm-min-w-[120px] arcm-px-4 arcm-py-2.5 arcm-rounded-lg arcm-bg-slate-100 arcm-transition-all hover:arcm-bg-[#F44336] hover:arcm-text-white'
              >
                Cancel
              </button>
            </div>
          ) : (
            <div className='arcm-text-center arcm-my-6'>
              {awsConnection ? (
                <>
                  <div className='icon arcm-inline-flex arcm-mb-6'>
                    <svg
                      xmlns='http://www.w3.org/2000/svg'
                      width='60'
                      height='60'
                      viewBox='0 0 60 60'
                      fill='none'
                    >
                      <path
                        d='M30 60C46.5685 60 60 46.5685 60 30C60 13.4315 46.5685 0 30 0C13.4315 0 0 13.4315 0 30C0 46.5685 13.4315 60 30 60Z'
                        fill='#27D935'
                      />
                      <path
                        d='M30 60C46.5685 60 60 46.5685 60 30C60 13.4315 46.5685 0 30 0C13.4315 0 0 13.4315 0 30C0 46.5685 13.4315 60 30 60Z'
                        fill='#27D935'
                      />
                      <path
                        fill-rule='evenodd'
                        clip-rule='evenodd'
                        d='M14.5801 31.414L24.5801 41.414C25.3601 42.196 26.6281 42.196 27.4081 41.414L45.4081 23.414C46.1881 22.634 46.1881 21.366 45.4081 20.586C44.6281 19.806 43.3601 19.806 42.5801 20.586L25.9941 37.172L17.4081 28.586C16.6281 27.806 15.3601 27.806 14.5801 28.586C13.8001 29.366 13.8001 30.634 14.5801 31.414Z'
                        fill='white'
                      />
                    </svg>
                  </div>
                  <h5 className='arcm-text-gray-900 arcm-text-base arcm-font-semibold arcm-mb-1.5'>
                    Connection to the database has been successfully established
                  </h5>
                  <p className='arcm-max-w-[384px] arcm-ml-auto arcm-mr-auto arcm-text-gray-900 arcm-text-sm arcm-font-normal arcm-mb-6'>
                    {ConnectionErrorMsg}
                  </p>
                  <button
                    onClick={handleToggleModal}
                    className='arcm-text-white arcm-text-sm arcm-font-semibold arcm-px-4 arcm-py-3 arcm-min-w-[120px] arcm-bg-[#3858e9] arcm-rounded-lg arcm-justify-center arcm-items-center arcm-gap-2 arcm-inline-flex arcm-transition-all hover:arcm-bg-blue-700'
                  >
                    <span>Done</span>
                  </button>
                </>
              ) : (
                <>
                  <div className='icon arcm-inline-flex arcm-mb-6'>
                    <svg
                      xmlns='http://www.w3.org/2000/svg'
                      x='0px'
                      y='0px'
                      width='100'
                      height='100'
                      viewBox='0 0 48 48'
                    >
                      <path
                        fill='#f44336'
                        d='M44,24c0,11.045-8.955,20-20,20S4,35.045,4,24S12.955,4,24,4S44,12.955,44,24z'
                      ></path>
                      <path
                        fill='#fff'
                        d='M29.656,15.516l2.828,2.828l-14.14,14.14l-2.828-2.828L29.656,15.516z'
                      ></path>
                      <path
                        fill='#fff'
                        d='M32.484,29.656l-2.828,2.828l-14.14-14.14l2.828-2.828L32.484,29.656z'
                      ></path>
                    </svg>
                  </div>
                  <h5 className='arcm-text-gray-900 arcm-text-base arcm-font-semibold arcm-mb-1.5'>
                    Connection can't be established
                  </h5>
                  <p className='arcm-max-w-[384px] arcm-ml-auto arcm-mr-auto arcm-text-gray-900 arcm-text-sm arcm-font-normal arcm-mb-6'>
                    {ConnectionErrorMsg}
                  </p>
                  <button
                    onClick={handleToggleModal}
                    className='arcm-text-white arcm-text-sm arcm-font-semibold arcm-px-4 arcm-py-3 arcm-min-w-[120px] arcm-bg-[#3858e9] arcm-rounded-lg arcm-justify-center arcm-items-center arcm-gap-2 arcm-inline-flex arcm-transition-all hover:arcm-bg-blue-700'
                  >
                    <span>Ok</span>
                  </button>
                </>
              )}
            </div>
          )
        }}
      </Modal>
    </div>
  )
}

export default AwsConfigure
